import {ACCESS_TOKEN, DEFTER_CONTROL_API_BASE_URL} from '../constants';
import * as axios from "axios";

import jwtDecode from "jwt-decode";

export function getIdToken() {
  const idToken = localStorage.getItem(ACCESS_TOKEN);
  if (!idToken) {
    console.log("ERROR: no id token found!");
  }
  return idToken;
}

export function isTokenExpired() {
  let token = getIdToken();
  if (token && 'undefined' !== token) {
    let decoded = jwtDecode(token);
    let current_time = Date.now() / 1000;
    return decoded.exp < current_time;
  } else{
    return true;
  }
}

export function isAuthenticated(){
  if (isTokenExpired()){
    localStorage.clear();
    return false;
  }
  return true;
}

export function request(options, headers) {
  let defaultHeaders = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  defaultHeaders = Object.assign(defaultHeaders, headers);

  if (localStorage.getItem(ACCESS_TOKEN)) {
    defaultHeaders['Authorization'] = 'Bearer ' + localStorage.getItem(ACCESS_TOKEN);
  }

  const defaults = {headers: defaultHeaders};
  options = Object.assign({}, defaults, options);

  return axios(options);
}

export function requestDC(options, headers) {
  let defaultHeaders = {
    'Content-Type': 'application/json;charset=UTF-8'
  };

  defaultHeaders = Object.assign(defaultHeaders, headers);

  if (localStorage.getItem(ACCESS_TOKEN)) {
    defaultHeaders['Authorization'] = 'Bearer ' + localStorage.getItem(ACCESS_TOKEN);
  }

  const defaults = {headers: defaultHeaders, baseURL: DEFTER_CONTROL_API_BASE_URL};
  options = Object.assign({}, defaults, options);

  return axios(options);
}

export function requestOut(options, headers) {
  let defaultHeaders = {
    'Content-Type': 'application/json;charset=UTF-8',
  };

  defaultHeaders = Object.assign(defaultHeaders, headers);

  const defaults = {headers: defaultHeaders};
  options = Object.assign({}, defaults, options);

  return axios(options);
}

export function generateURL(url) {
  let includesQuery = (url.indexOf("?") !== -1);
  let token = "Bearer " + localStorage.getItem("accessToken");
  let authQuery = `auth=${encodeURI(token)}`
  if (includesQuery) {
    url += `&${authQuery}`
  } else {
    url += `?${authQuery}`
  }
  return url;
}

export function login(loginRequest) {
  return request({
    url: "/auth/signin",
    method: 'post',
    data: loginRequest
  });
}

export function getCurrentUser() {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return request({
    url: "/user/me",
    method: 'get'
  });
}

export function requestIVD(options, headers){
  let defaultHeaders = {
    'Content-Type': 'application/json;charset=UTF-8'
  };

  defaultHeaders = Object.assign(defaultHeaders, headers);

  const defaults = {headers: defaultHeaders};
  options = Object.assign({}, defaults, options);

  return axios(options);
}

export function getCustomerCity(){
  return request({
    url:"/customer/getCustomerAllCity",
    method:"get"
  });
}
